import React from 'react'
import Banner from '../Components/Banner'
import BlogClassic from '../Components/Blog/BlogClassic'
const Blog = () => {
  return (
   <>
   <Banner heading={"Blog Classic"} text={"Blog Classic"}/>
   <BlogClassic/>
   </>
  )
}

export default Blog